import {
  ListCreditsSupplierQuery,
  SupplierOrderColumn,
} from '@/core/domain/people/Suppliers/Suppliers.types';
import { ItemsPurchaseReturnAll } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { tableSorterOrder } from '@/utils/table';
import { SorterResult } from 'antd/lib/table/interface';
import { Dispatch, SetStateAction } from 'react';

export default function supplierReturnedItemsOrderColumns(
  sorter: SorterResult<ItemsPurchaseReturnAll>,
  setQueryParams: Dispatch<SetStateAction<ListCreditsSupplierQuery>>,
) {
  if (sorter && sorter.columnKey) {
    setQueryParams((prev) => {
      const order = sorter.order ? tableSorterOrder[sorter.order] : undefined;
      const orderByColumn = sorter.columnKey as SupplierOrderColumn;

      return {
        ...prev,
        order,
        orderByColumn,
      };
    });
  }
}
